module.exports = __webpack_public_path__ + "static/img/8.7d08ab5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/zh/8.png
// module id = LI86
// module chunks = 0